import { countries } from '../../constants/countries';

export const getCountryFlag = (countryCode: string): string => {
  const country = countries.find(({ iso2 }) => iso2 === countryCode);
  return country ? country.unicodeFlag : '';
};
